module.exports = __webpack_public_path__ + "img/HC1030-193.f36fb8f5.jpg";